import { Injectable } from '@angular/core';

import { IRewardTokensState, defaultRewardTokensState } from './state';

@Injectable()
export class RewardTokensStateStorageService {
    load(state: IRewardTokensState): IRewardTokensState {
        return {
            ...defaultRewardTokensState,
            ...state,
            betstationTokens: {
                bogTokenState: {
                    selectedTokenId: null,
                    eligibility: null,
                },
                betStationFreeBet: {
                    selectedTokenId: null,
                    eligibility: null,
                },
                edsState: {
                    selectedTokenIds: [],
                    eligibilities: [],
                },
            },
            tokenRecoveryState: [],
            eligibilityState: {
                singleBet: {},
                comboBet: [],
                teaserBet: [],
                betBuilder: {},
            },
        };
    }
}
